
/* eslint-disable */
import { mapMutations, mapGetters } from "vuex";
import oneSignal from "@/api/onesignal";
import userOneSignal from "@/api/user_one_signal";
import configVars from "@/config/config_vars";
export default {
  name: "signin",
  components: {},
  computed: mapGetters({
    user: "user/user",
    isAutenticated: "user/isAutenticated",
    imgSrc: "user/imgSrc"
  }),
  data() {
    return {
      ALLOW_DISALOW: "ALLOW",
      dialogMessage: {
        model: true,
        title: "",
        message: ""
      }
    };
  },

  mounted() {
    document.addEventListener("keydown", e => {
      if (e.keyCode == 27) {
        this.close();
      }
    });
    this.$nextTick(async () => {
      this.dialogMessage = {
        model: true,
        title: "Notification",
        message: "---------------"
      };


      /*this.$OneSignal?.push(() => {
        this.$OneSignal?.getSubscription(notOptedOut => {
          if (notOptedOut) {
            this.$OneSignal?.registerForPushNotifications({
              modalPrompt: true
            });
          }
        });
      });*/
      try{
        Promise.all([
          this.$OneSignal?.isPushNotificationsEnabled(),
          this.$OneSignal?.getUserId(),
          this.$OneSignal?.getRegistrationId(),
          this.$OneSignal?.getNotificationPermission(),
          this.$OneSignal?.isOptedOut()
          //this.$OneSignal?.context.serviceWorkerManager.getActiveState()
        ])
          .then(
            ([
              isSubscribed,
              userId,
              registrationId,
              notificationPermission,
              optedOut
              //serviceWorkerActive
            ]) => {

            }
          )
          .catch(e => {

          });

        this.$OneSignal?.push(() => {
          this.$OneSignal?.isPushNotificationsEnabled(isEnabled => {
            if (isEnabled) {

              //this.$OneSignal?.push(["registerForPushNotifications"]);
              this.$OneSignal?.push(() => {
                this.$OneSignal?.getUserId(async oneSignalID => {

                });
              });
            } else {

              this.$OneSignal?.push(() => {
                this.$OneSignal?.getUserId(async oneSignalID => {

                });
              });
            }
          });

          this.$OneSignal?.on("notificationPermissionChange", permissionChange => {
            var currentPermission = permissionChange.to;

          });

          this.$OneSignal?.on("subscriptionChange", isSubscribed => {

            this.$OneSignal?.push(() => {
              this.$OneSignal?.getUserId(async oneSignalID => {


                let userOneSignalObjet = {
                  one_signal_id: oneSignalID
                };

                let coordinates = this.$store.getters["coordinates"];
                if (coordinates) {
                  if (coordinates.lat && coordinates.lon) {

                    userOneSignalObjet.coordinates = {
                      lat: coordinates.lat,
                      lon: coordinates.lon
                    };
                  }
                }

                let userOneSignalRes = await userOneSignal.createUpdateUserOneSignal(
                  userOneSignalObjet
                );
              });
            });
          });
        });
      }catch(error){

      }
    });
  },
  watch: {},
  methods: {
    dialogClick() {
      this.dialogMessage.model = true;
    },
    close() {
      this.$emit("close");
    },
    async sendNotification() {


      this.$OneSignal?.getUserId(async oneSignalID => {

        let oneIDs = [];
        oneIDs.push(oneSignalID);

        let respuesta = {};
        try {
          respuesta = await oneSignal.sendNotification(oneIDs);
        } catch (e) {

        }
        if (respuesta.data) {
          if (respuesta.data.recipients) {

          } else {

          }
        } else {

        }


        if (oneSignalID) {
          if (oneSignalID.length > 0) {
            let userOneSignalObjet = {
              one_signal_id: oneSignalID
            };

            let coordinates = this.$store.getters["coordinates"];
            if (coordinates) {
              if (coordinates.lat && coordinates.lon) {

                userOneSignalObjet.coordinates = {
                  lat: coordinates.lat,
                  lon: coordinates.lon
                };
              }
            }

            let userOneSignalRes = await userOneSignal.createUpdateUserOneSignal(
              userOneSignalObjet
            );

          }
        }
      });
    },

    allowPushNotificationClick() {
      this.$OneSignal?.push(() => {
        return Promise.all([
          this.$OneSignal?.isPushNotificationsEnabled(),
          this.$OneSignal?.isOptedOut()
        ]).then(result => {
          var isPushEnabled = result[0];
          var isOptedOut = result[1];
          if (isPushEnabled) {

            this.$emit("close");
          } else {
            this.$OneSignal?.push([
              "getNotificationPermission",
              permission => {

                // three cases here
                if (permission === "default") {
                } else if (permission === "denied") {
                } else {
                }
              }
            ]);

            if (isOptedOut) {
              /* Opted out, opt them back in */

              if (Notification.permission !== "granted") {
                Notification.requestPermission();

              }

              this.$OneSignal?.setSubscription(true);

              this.$OneSignal?.push(() => {
                this.$OneSignal?.isPushNotificationsEnabled(isEnabled => {
                  if (isEnabled) {

                    //this.$OneSignal?.push(["registerForPushNotifications"]);
                    this.$OneSignal?.push(() => {
                      this.$OneSignal?.getUserId(async oneSignalID => {

                      });
                    });
                  } else {

                    this.$OneSignal?.setSubscription(true);
                    this.$OneSignal?.push(() => {
                      this.$OneSignal?.getUserId(async oneSignalID => {

                      });
                    });
                  }
                });
              });
              this.$emit("close");
            } else {
              /* Unsubscribed, subscribe them */
              if (Notification.permission !== "granted") {
                Notification.requestPermission();

                if (Notification.permission === "denied") {
                  this.dialogMessage.model = true;
                  this.dialogMessage.title = "Notification";
                  this.dialogMessage.message =
                    "You have denied push notifications. You can activate them on your explorer configuration";

                  alert(
                    "You have denied push notifications. You can activate them on your explorer configuration"
                  );
                  //this.$OneSignal?.showNativePrompt();
                  /*this.$OneSignal?.push(() => {
                    this.$OneSignal?.showSlidedownPrompt();
                  });*/
                }
              }


              this.$OneSignal?.registerForPushNotifications();
              this.$OneSignal?.push(() => {
                this.$OneSignal?.showNativePrompt();
              });
              this.$emit("close");
            }
          }
        });
      });
    },

    disAllowPushNotificationClick() {
      this.$OneSignal?.push(() => {
        return Promise.all([
          this.$OneSignal?.isPushNotificationsEnabled(),
          this.$OneSignal?.isOptedOut()
        ]).then(result => {
          var isPushEnabled = result[0];
          var isOptedOut = result[1];
          if (isPushEnabled) {

            this.$OneSignal?.setSubscription(false);
          } else {
          }

          this.$emit("close");
        });
      });
    },

    onManageWebPushSubscriptionButtonClicked() {

      return Promise.all([
        this.$OneSignal?.isPushNotificationsEnabled(),
        this.$OneSignal?.isOptedOut()
      ]).then(result => {
        var isPushEnabled = result[0];
        var isOptedOut = result[1];


        if (isPushEnabled) {
          /* Subscribed, opt them out */
          this.$OneSignal?.setSubscription(false);

          this.ALLOW_DISALOW = "DISALLOW";
        } else {
          if (isOptedOut) {
            /* Opted out, opt them back in */
            this.$OneSignal?.setSubscription(true);

          } else {
            /* Unsubscribed, subscribe them */

            this.$OneSignal?.registerForPushNotifications();
          }
        }
      });
    }
  }
};
